/**
 * Icon Color
 */
export var ViewColor;
(function (ViewColor) {
    ViewColor["SUCCESS"] = "SUCCESS";
    /** @deprecated use ERROR instead */
    ViewColor["DANGER"] = "DANGER";
    ViewColor["ERROR"] = "ERROR";
    ViewColor["INFO"] = "INFO";
    ViewColor["WARNING"] = "WARNING";
    ViewColor["TERTIARY"] = "TERTIARY";
    ViewColor["WHITE"] = "WHITE";
})(ViewColor || (ViewColor = {}));
export var JustifyContent;
(function (JustifyContent) {
    JustifyContent["SPACE_BETWEEN"] = "space-between";
    JustifyContent["SPACE_AROUND"] = "space-around";
    JustifyContent["FLEX_START"] = "flex-start";
    JustifyContent["FLEX_END"] = "flex-end";
    JustifyContent["CENTER"] = "center";
})(JustifyContent || (JustifyContent = {}));
//# sourceMappingURL=ViewEnum.js.map